export default () => ({
  lessons: [],
  lessonsPreview: [],
  currentLesson: null,
  currentContent: null,
})
